import { MdmProvider, MdmUpdateIntent } from '@/types'

export const MDM_PROVIDER_OPTIONS = [
  { id: MdmProvider.Intune, title: 'Microsoft Intune' },
  { id: MdmProvider.Jamf, title: 'Jamf Pro' },
  { id: MdmProvider.Kandji, title: 'Kandji' },
  { id: MdmProvider.Mosyle, title: 'Mosyle' },
  { id: MdmProvider.WorkspaceOne, title: 'Workspace ONE' },
  { id: MdmProvider.Jumpcloud, title: 'JumpCloud' },
  { id: MdmProvider.Rippling, title: 'Rippling' },
  { id: MdmProvider.Fleet, title: 'Fleet' },
  { id: MdmProvider.Munki, title: 'Munki' },
  { id: MdmProvider.Other, title: 'Other' },
]

export const MDM_UPDATE_INTENT_OPTIONS = [
  {
    id: MdmUpdateIntent.Auto,
    title: 'Automatic',
    helperText: 'Devices update themselves and stay on the latest version.',
  },
  { id: MdmUpdateIntent.Manual, title: 'Manual', helperText: 'We deploy every new version ourselves through our MDM.' },
]

const labelFor = (options: { id: string; title: string }[], id: string): string =>
  options.find((option) => option.id === id)?.title ?? id

export const mdmProviderLabel = (id: string): string => labelFor(MDM_PROVIDER_OPTIONS, id)

export const mdmUpdateIntentLabel = (id: string): string => labelFor(MDM_UPDATE_INTENT_OPTIONS, id)
